export default "__VITE_ASSET__VCOTdKq8__"